import styled from "styled-components";

export const IconModal = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 150px;
    margin-left: 20px;
`;
export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;
    width: 100%;
`;


export const ButtonCloseModal = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 70px;
    margin-top: -20px;

    &:hover {
        cursor: pointer;
        transform: scale(1.2);
    }
`;

export const ModalContent = styled.div`
    padding: 10px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ModalTitle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 25px 0;
    gap: 10px;

    h1 {
        font-size: 20px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.interfaceText500};
    }

    p {
        font-size: 14px;
        font-weight: 500;
        color: ${({ theme }) => theme.colors.interfaceText300};
        text-align: center;
    }
`;

export const ModalForm = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    width: 100%;
    /* padding: 0 20px; */
    margin: 10px 0;

    .input-full { width: 100%; }

    span {
        color: ${({ theme }) => theme.colors.primaryRed400};
    }
`;

export const ModalBoard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    width: 95%;
    margin: 25px 0;
    gap: 10px;
    border-radius: 8px;
    padding: 15px 30px;
    max-width: 450px;
    color: ${({ theme }) => theme.colors.interfaceText400};
    border: 1px solid ${({ theme }) => theme.colors.secondaryPool500};
    background-color: ${({ theme }) => theme.colors.secondaryPool100};

    ul { gap: 30px; }
    li { list-style-type: disc; }
    li::marker { color: ${({ theme }) => theme.colors.interfaceText400}; }
`;